import React from "react";
import { isEmail } from "../utils";
import Button from "storybookComponents/Button";
import Chips from "storybookComponents/Chips";

const BCCList = ({ classes, bccList, handleBccList, handleSave, state, handleResetClick }) => {
  return (
    <div className={classes.collapseContentWrapper}>
      <div className={classes.text1}>
        Please add all the email addresses that need to be BCC'd to all the e-blasts
      </div>

      <Chips
        propValues={bccList}
        label="Email(s)"
        onChangeCallback={handleBccList}
        helperText="Press ‘Enter’ or ‘Comma’ to add multiple emails"
        placeholder=""
        className={classes.chipsWrapper}
        validator={isEmail}
      />

      <div className={classes.bccList}>
        <Button className={classes.btn} state={state} onClick={handleSave}>
          Save
        </Button>
        <Button
          className={classes.rstBtn}
          variant="tertiary"
          state={state}
          onClick={handleResetClick}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default BCCList;
